/*global angular*/
var bibWidget = angular.module('bibWidget', ['odetManager']);
bibWidget.directive('bibWidget', ['$q', 'odetManager', 'bibContentManager', 'settings', 'termHelper', '$notification', 'messages', '$uibModal', '$transitions',
  function ($q, odetManager, bibContentManager, settings, termHelper, $notification, messages, $uibModal, $transitions) {
    'use strict';
    return {
      restrict: 'E',
      template: require('./bibWidget.html'),
      replace: true,
      transclude: true,
      scope: {
        item: '=',
        field: '<',
        odet: '<'
      },
      //require: [ '^xyz' ], //requires a controller from the parent scope
      link: function (scope, element, attrs) {
        var offset = 140;

        scope.$watch('item', function (item) {
          scope.loadingBib = true;
          scope.loadingOdet = true;
          scope.loadingTerm = true;
          scope.concordanties = {};
          odetManager.getCurriculum().then(function (odet) {
            scope.loadingOdet = false;
            scope.levels = [];
            scope.noConcordanties = true;
            odet.levels.forEach(function (level) {
              scope.levels.push({
                key: level.key,
                title: level.title
              });
              scope.concordanties[level.key] = [];
              odetManager.getConcordantieByZillGoal(level.key, scope.item.key)
                .then(function (results) {
                  scope.concordanties[level.key] = results;
                  if (results.length > 0) {
                    scope.noConcordanties = false;
                  }
                });
            });
          });
          function handleTerms(results) {
            scope.loadingTerm = false;
            scope.terms = [];
            results.forEach(function (result) {
              scope.terms.push(result);
            });
          }
          if (scope.odet) {
            bibContentManager.getContentReferencedFromContentRoot('/content/' + item.key, ['TERM'])
              .then(
                handleTerms,
                function () {
                  $notification.error(messages.search.errorTerms);
                });
          } else {
            bibContentManager.getContentReferencedFromContent('/content/' + item.key, ['TERM'])
              .then(handleTerms,
                function () {
                  $notification.error(messages.search.errorTerms);
                });
          }

          bibContentManager.getContentUnder('/content/' + item.key, ['ZILL_ILLUSTRATION'], null, {limit: 5, relatedToCurriculumContent: item.$$meta.permalink}).then(function (results) {
            scope.loadingBib = false;
            scope.documents = results;
          }, function (err) {
            console.error(err);
          });

        });
        if (scope.odet) {
          scope.activeTab = 'bib';
        } else {
          scope.activeTab = 'begrippen';
        }

        scope.getTabStyle = function (tab) {
          var style;
          if (tab === scope.activeTab) {
            style = {
              'border-bottom-color': scope.field.color,
              color: scope.field.color,
              'font-weight': 'bold'
            };
          } else {
            style = {};
          }
          return style;
        };

        function elmYPosition(eID) {
          var elm = document.getElementById(eID);
          if (!elm) {
            console.warn(eID + ' is not found');
          } else {
            var y = elm.offsetTop;
            var node = elm;
            while (node.offsetParent && node.offsetParent != document.body) {
              node = node.offsetParent;
              y += node.offsetTop;
            }
            return y;
          }
        }

        scope.openTerm = function (term) {
          termHelper.openTerm(term.key, scope.item.key);
        };

        scope.openOdet = function (type) {
          $uibModal.open({
            animation: true,
            template: require('../../screen/modals/odet.html'),
            controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
              $scope.goal = scope.item;
              $scope.field = scope.field;
              $scope.type = type;
              $scope.levels = _.cloneDeepWith(scope, function (value, key) {
                if (_.isElement(value)) {
                  if (key === 'title') {
                    value.cloneNode(true);
                  } else {
                    value.cloneNode(false);
                  }
                }
              }).levels.map(l => {
                l.title = l.title.toLowerCase().replace('eindtermen', '');
                l.title = l.title.toLowerCase().replace('ontwikkelingsdoelen', '');
                return l;
              }).filter(o => scope.concordanties[o.key].length > 0);
              $scope.close = function () {
                $uibModalInstance.dismiss('cancel');
              };
              $transitions.onExit({}, function (e, b, c) {
                $uibModalInstance.dismiss('cancel');
              });
            }]
          });
        };

      }
    };
  }]);
module.exports = bibWidget;



// WEBPACK FOOTER //
// ./web/js/module/bibWidget/bibWidget.js